export enum SnPlayerState {
  Pending = 'pending',
  Playing = 'playing',
  Pause = 'pause',
  Ended = 'ended',
}
